import { render, staticRenderFns } from "./CRMRelationshipList.vue?vue&type=template&id=aeacf338"
import script from "./CRMRelationshipList.vue?vue&type=script&lang=js"
export * from "./CRMRelationshipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports